import { Box } from '@chakra-ui/react'
import { useParams } from 'react-router-dom'

import GoalForm from './goalForm'

import useGetObject from '@app/hooks/useGetObject'

const Create = () => {
  const { nodeId } = useParams()
  const metric = useGetObject(nodeId, 'metric')

  return (
    <Box p={6}>
      <GoalForm goal={null} metric={metric} />
    </Box>
  )
}

export default Create
